//on ready
$(document).ready(function () {


    fullheight.style.height = height + "px";
    
    //$body.rhLoadIn();

    // $('#ajaxContainer').rhLoadIn({
    //     ajax:true
    // });


    // $body.rhLoadIn();

    // $(".parallax").rhParallax({
    //     parallaxRatio: 1.4
    // });

    //images loaded
    // $(".bgImgLoad").imagesLoaded({ background: ".bgImgLoad" }, function () {
    //     $(".bgImgLoad").animate({ opacity: "1" }, 300);
    // });

    // $(".imgLoad").imagesLoaded(function () {
    //     $(".imgLoad").animate({ opacity: "1" }, 300);
    // });
}); // end doc ready